/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerError } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : STORYTITLE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    storytitle: {
        height: '70%',
        textAlign: 'left',
        position: 'relative',
        zIndex: '3',
        '& .text': {
            height: '100%',
            fontSize: pxToEm(23),
            fontWeight: 'bold',
            lineHeight: '1.1',
            border: replacePXinStringWithEM('1px solid transparent'),
            padding: pxToEm(10),
            transition: 'border-width 0.2s ease-out',
            '&.medium': { fontSize: pxToEm(18), lineHeight: '1.15' },
            '&.large': { fontSize: pxToEm(16), lineHeight: '1.15' },
            '&.xlarge': { fontSize: pxToEm(15), lineHeight: '1.15' },
            '&.xxlarge': { fontSize: pxToEm(13), lineHeight: '1.25' },
            '&.xxxlarge': { fontSize: pxToEm(12), lineHeight: '1.25' },
            '& .editabletext': {
                textDecoration: 'underline'
            },
            '& .editabletext:empty': {
                textDecoration: 'none'
            }
        },
        '&.valid-false': {
            extend: answerError.text
        },
        // not supported in IE https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
        '&:focus-within': {
            border: replacePXinStringWithEM('1px solid #fff'),
            transition: 'border-width 0.2s ease-in'
        }
    }
});